// Admin › Tagsági kártya (előnézet) (v165): a kártya KITALÁLT adatokkal, minden állapotban; a becenév szerkeszthető (hosszú név próba).
// Nincs szerverhívás, nincs valódi tagadat: a tervező és Tamás ezen nézi a megjelenést (telefon/asztali, hosszú név).

import { t } from "./i18n.js";
import { el } from "./dom.js";
import { renderTagsagiKartya, KARTYA_ALLAPOTOK, tagsagiSzamSzoveg } from "./tagsagiKartya.js";
import { renderNevNaplo } from "./nevNaploView.js";

const ALLAPOT_KULCS_MODUL = { active: "card.statusActive", grace: "card.statusGrace", suspended: "card.statusSuspended", expired: "card.statusExpired" };

const MINTA = { nickname: "Sanyi", number: 5237, joinedYear: 2026, joinedMonth: 10 };

/** Az előnézet állapota modulszintű (nincs mentés): { status, nickname }. */
const allapot = { status: "active", nickname: MINTA.nickname };

export function renderKartyaElonezet(model, handlers = {}) {
  const uiLang = model.uiLang;
  const szekcio = el("section", { class: "panel-section admin-card-preview" });
  szekcio.appendChild(el("h3", { text: t(uiLang, "admin.cardMenu") }));
  szekcio.appendChild(el("p", { class: "hint", text: t(uiLang, "admin.cardHint") }));

  const hely = el("div", { class: "admin-card-holder" });
  const rajzol = () => {
    hely.textContent = "";
    hely.appendChild(renderTagsagiKartya({ uiLang, ...MINTA, nickname: allapot.nickname, status: allapot.status }));
    for (const b of gombok.querySelectorAll("button")) b.setAttribute("aria-pressed", b.dataset.status === allapot.status ? "true" : "false");
  };
  const gombok = el("div", { class: "panel-row admin-card-states" });
  const ALLAPOT_KULCS = { active: "card.statusActive", grace: "card.statusGrace", suspended: "card.statusSuspended", expired: "card.statusExpired" };
  for (const s of KARTYA_ALLAPOTOK) {
    gombok.appendChild(el("button", { type: "button", class: "neutral-btn compact", "data-status": s, text: t(uiLang, ALLAPOT_KULCS[s]), onclick: () => { allapot.status = s; rajzol(); } }));
  }
  szekcio.appendChild(gombok);

  const nev = el("input", { type: "text", class: "panel-input admin-card-nickname", maxlength: "160", "aria-label": t(uiLang, "card.nickname"), placeholder: t(uiLang, "card.nickname") });
  nev.value = allapot.nickname;
  nev.addEventListener("input", () => { allapot.nickname = nev.value; rajzol(); });
  szekcio.appendChild(nev);
  szekcio.appendChild(hely);
  rajzol();

  // --- Tagnyilvántartás (v166): az aktív tagok, a tagsági szám kiadása és az állapot állítása (fizetés nélkül)
  szekcio.appendChild(el("h3", { text: t(uiLang, "admin.cardMembers") }));
  // A tagság hatása a hozzáférésre (v177): alapból KI; BE állapotban a felfüggesztett / lejárt tag nem fér hozzá (admint nem érinti).
  const enforce = model.membersEnforce === true;
  szekcio.appendChild(el("p", { class: "hint admin-card-enforce-hint", text: t(uiLang, "admin.cardEnforceHint") }));
  szekcio.appendChild(el("button", {
    type: "button", class: `${enforce ? "primary-btn" : "neutral-btn"} compact admin-card-enforce`, "aria-pressed": enforce ? "true" : "false",
    text: t(uiLang, enforce ? "admin.cardEnforceOn" : "admin.cardEnforceOff"), disabled: model.busy === true,
    onclick: () => handlers.onMemberEnforce && handlers.onMemberEnforce(!enforce),
  }));
  // A névváltozás naplója (D-010, v185): alapból KI; személyes adat, ezért bekapcsolás előtt az adatkezelési szabályokat tisztázni kell.
  const nevNaplo = model.membersNameLog === true;
  szekcio.appendChild(el("p", { class: "hint admin-card-namelog-hint", text: t(uiLang, "nameLog.hint") }));
  szekcio.appendChild(el("button", {
    type: "button", class: `${nevNaplo ? "primary-btn" : "neutral-btn"} compact admin-card-namelog`, "aria-pressed": nevNaplo ? "true" : "false",
    text: t(uiLang, nevNaplo ? "nameLog.on" : "nameLog.off"), disabled: model.busy === true,
    onclick: () => handlers.onMemberNameLogSwitch && handlers.onMemberNameLogSwitch(!nevNaplo),
  }));
  szekcio.appendChild(el("button", { type: "button", class: "neutral-btn compact admin-card-refresh", text: t(uiLang, "search.refresh"), disabled: model.busy === true, onclick: () => handlers.onMemberRefresh && handlers.onMemberRefresh() }));
  if (model.membersHiba === true) szekcio.appendChild(el("div", { class: "panel-status err admin-card-hiba", text: t(uiLang, "admin.cardLoadFailed") }));
  if (model.membersMuveletHiba === true) szekcio.appendChild(el("div", { class: "panel-status err admin-card-hiba", text: t(uiLang, "admin.cardFailed") }));
  const tagok = Array.isArray(model.members) ? model.members : null;
  if (tagok === null) {
    if (model.membersHiba !== true) szekcio.appendChild(el("p", { class: "hint", text: t(uiLang, "common.loading") }));
  } else {
    const lista = el("div", { class: "panel-list admin-card-members" });
    for (const m of tagok) {
      const sor = el("div", { class: "user-row admin-card-member" });
      const szoveg = el("div", { class: "user-row-text" });
      szoveg.appendChild(el("div", { class: "primary", text: m.name || m.uid }));
      szoveg.appendChild(el("div", { class: "sub", text: m.member ? `${tagsagiSzamSzoveg(m.member.number)} · ${t(uiLang, ALLAPOT_KULCS_MODUL[m.member.status] || "card.statusExpired")}` : t(uiLang, "admin.cardNoNumber") }));
      // Diagnosztika (v177): a szerepkör és a tükör — az admint a tagság nem tiltja, ezért ez a sor megmutatja, ha a tiltás emiatt marad el.
      if (m.role === "admin" || (m.mirror && m.mirror.block === true && m.blocked !== true)) {
        szoveg.appendChild(el("div", { class: "sub admin-card-role", text: `${t(uiLang, "admin.roleAdmin")}${m.mirror && m.mirror.block === true ? " · ⛔ (a tagság az admint nem tiltja)" : ""}` }));
      }
      if (m.blocked === true) szoveg.appendChild(el("div", { class: "sub admin-card-blocked", text: `⛔ ${t(uiLang, "admin.cardBlocked")}` }));
      sor.appendChild(szoveg);
      const gombsor = el("div", { class: "row-actions" });
      if (!m.member) {
        gombsor.appendChild(el("button", { type: "button", class: "primary-btn compact admin-card-issue", text: t(uiLang, "admin.cardIssue"), disabled: model.busy === true, onclick: () => handlers.onMemberIssue && handlers.onMemberIssue(m.uid) }));
      } else {
        for (const s of KARTYA_ALLAPOTOK) {
          const g = el("button", { type: "button", class: "neutral-btn compact admin-card-set", "data-status": s, text: t(uiLang, ALLAPOT_KULCS_MODUL[s]), disabled: model.busy === true || m.member.storedStatus === s, onclick: () => handlers.onMemberStatus && handlers.onMemberStatus(m.uid, s) });
          gombsor.appendChild(g);
        }
      }
      // Névváltozások (D-010): csak bekapcsolt naplónál; a lista a sor alatt nyílik (az olvasás auditnaplóba kerül).
      if (nevNaplo) gombsor.appendChild(el("button", { type: "button", class: "neutral-btn compact admin-card-namelog-show", text: t(uiLang, "nameLog.show"), onclick: () => handlers.onMemberNameLog && handlers.onMemberNameLog(m.uid) }));
      sor.appendChild(gombsor);
      lista.appendChild(sor);
      if (nevNaplo && model.nameLogTag && model.nameLogTag.uid === m.uid) lista.appendChild(renderNevNaplo(uiLang, model.nameLogTag.entries));
    }
    szekcio.appendChild(lista);
  }
  return szekcio;
}
